import type * as React from 'react';

import { Button } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ErrorState } from '@/components/shell';
import { Routes } from '@/constants/routes';

export const ForbiddenPage = (): React.JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <ErrorState
      data-testid="forbidden-page"
      icon={<BlockIcon />}
      code={t('forbidden.code')}
      title={t('forbidden.title')}
      description={t('forbidden.description')}
      actions={
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(Routes.HOME)}
          sx={{ minHeight: 44 }}
        >
          {t('backToOverview')}
        </Button>
      }
    />
  );
};
